'use client';
import NextLink from '@/components/next-link';
import { usePathname } from '@/i18n/navigation';
import { useTranslations } from 'next-intl';

function MenuItem({ menu }) {
  const pathname = usePathname();
  const t = useTranslations('user');

  const isActive =
    pathname === menu.href ||
    (pathname.startsWith(menu.href + '/') && menu.href !== '/user');

  return (
    <NextLink
      key={menu.href}
      href={menu.href}
      className={`flex flex-col items-center justify-center gap-4 rounded-lg border px-2.5 py-7 text-center max-lg:flex-row max-lg:gap-3 max-lg:py-2.5 max-md:gap-2.5 max-sm:gap-1.5 max-sm:py-2 sm:min-w-50 lg:min-h-[180px] lg:w-[185px] ${isActive ? 'bg-primary border-transparent text-white' : 'hover:bg-primary border-[#E4E4F9] hover:border-transparent hover:text-white'}`}
    >
      {menu.icon}
      <h3 className='leading-[120%] font-bold max-lg:whitespace-nowrap max-md:text-sm max-sm:text-xs md:text-[15px] lg:-mt-1.5 lg:text-base'>
        {t(menu.title)}
      </h3>
      <p className='text-[13px] leading-[154%] max-lg:hidden'>
        {t(menu.description)}
      </p>
    </NextLink>
  );
}

export default MenuItem;
